import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { LegislationEmployeeCostSectionRef } from "../../../../models/legislation-employee-cost-section/legislation-employee-cost-section-ref";
import { convertBooleanToYesOrNo } from "../../../../utils/convert-boolean-to-yes-or-no";
import { StyledTableCell } from "../styles";
interface Props {
  section: LegislationEmployeeCostSectionRef;
}

const EmployeeCostSectionConfigurationRow = ({ section }: Props) => {
  const tRP = "components.add_edit_legislation_employee_cost_section";
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell>{section.name}</TableCell>
      <StyledTableCell
        title={
          section.type?.isSocialSecurityRelevant
            ? "Social security section. Please check Social security section configuration"
            : ""
        }
        align="center"
        isSocialSecurity={section.type?.isSocialSecurityRelevant ?? false}
      >
        {section.rate > 0 ? section.rate : ""}
      </StyledTableCell>
      <StyledTableCell
        align="right"
        title={
          section.type?.isSocialSecurityRelevant
            ? "Social security section. Please check Social security section configuration"
            : ""
        }
        isSocialSecurity={section.type?.isSocialSecurityRelevant ?? false}
      >
        {section.fixedAmount > 0 ? section.fixedAmount.toLocaleCustom() : ""}
      </StyledTableCell>
      <StyledTableCell
        align="right"
        title={
          section.type?.isSocialSecurityRelevant
            ? "Social security section. Please check Social security section configuration"
            : ""
        }
        isSocialSecurity={section.type?.isSocialSecurityRelevant ?? false}
      >
        <Grid>
          <Typography variant="body2">
            {section.capAmount > 0 ? (
              <span title={`${t(`${tRP}.fields.cap_amount`)}`}>
                <FontAwesomeIcon icon={faCaretUp} />
                {section.capAmount.toLocaleCustom()}
              </span>
            ) : (
              ""
            )}
          </Typography>
          <Typography variant="body2">
            {section.minAmount > 0 ? (
              <span title={`${t(`${tRP}.fields.min_amount`)}`}>
                <FontAwesomeIcon icon={faCaretDown} />
                {section.minAmount.toLocaleCustom()}
              </span>
            ) : (
              ""
            )}
          </Typography>
        </Grid>
      </StyledTableCell>
      <TableCell align="right">
        <Grid>
          <Typography variant="body2">
            {section.dividedBy > 0 ? (
              <span title={`${t(`${tRP}.fields.divided_by`)}`}>/{section.dividedBy.toLocaleCustom()}</span>
            ) : (
              ""
            )}
          </Typography>
          <Typography variant="body2">
            {section.multipliedBy > 0 ? (
              <span title={`${t(`${tRP}.fields.multiplied_by`)}`}>*{section.multipliedBy.toLocaleCustom()}</span>
            ) : (
              ""
            )}
          </Typography>
        </Grid>
      </TableCell>
      <TableCell>
        {section.contributesTo.length > 0 ? (
          <Grid>
            <Typography variant="body2">
              {section.isSubstracted ? "Substracted from :" : "Added to :"}
              {section.contributesTo.map((sec, key) => (
                <Typography
                  key={key}
                  variant="body2"
                >
                  {sec.name}
                </Typography>
              ))}
            </Typography>
          </Grid>
        ) : (
          <></>
        )}
      </TableCell>
      <TableCell>{section.proportionalTo?.name}</TableCell>
      <TableCell align="center">{convertBooleanToYesOrNo(section.considerIncomeBrackets)}</TableCell>
    </TableRow>
  );
};
export default EmployeeCostSectionConfigurationRow;
